import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.PROD 
  ? 'https://cineclubs.cloud' 
  : 'http://localhost:3001';

let socket = null;

/**
 * Initialize socket connection
 */
export function initSocket() {
  if (socket?.connected) return socket;
  
  socket = io(SOCKET_URL, {
    path: '/stream-socket/',
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000
  });
  
  socket.on('connect', () => {
    console.log('✅ Socket connected:', socket.id);
  });
  
  socket.on('disconnect', (reason) => {
    console.log('🔌 Socket disconnected:', reason);
  });
  
  socket.on('connect_error', (err) => {
    console.warn('⚠️ Socket error:', err.message);
  });
  
  return socket;
}

/**
 * Get current socket instance
 */
export function getSocket() {
  if (!socket) {
    return initSocket();
  }
  return socket;
}

/**
 * Disconnect socket
 */
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Join a stream room
 */
export function joinStream(slug, user, role = 'viewer') {
  const s = getSocket();
  s.emit('stream:join', {
    slug,
    userId: user?.id,
    username: user?.username,
    role
  });
}

/**
 * Leave stream room
 */
export function leaveStream() {
  const s = getSocket();
  s.emit('stream:leave');
}

/**
 * Send chat message
 */
export function sendChatMessage(message) {
  const s = getSocket();
  s.emit('chat:send', { message });
}

/**
 * Send typing indicator
 */
export function sendTyping() {
  const s = getSocket();
  s.emit('chat:typing');
}

/**
 * Emit stream start
 */
export function emitStreamStart(data) {
  const s = getSocket();
  s.emit('stream:start', data);
}

/**
 * Emit stream stop
 */
export function emitStreamStop() {
  const s = getSocket();
  s.emit('stream:stop');
}

/**
 * Send gift
 */
export function sendGift(coins, message = '') {
  const s = getSocket();
  s.emit('gift:send', { coins, message });
}

/**
 * Request viewers list
 */
export function requestViewersList() {
  const s = getSocket();
  s.emit('viewers:list');
}

/**
 * Highlight/unhighlight a user
 */
export function emitUserHighlight(username, highlighted) {
  const s = getSocket();
  s.emit('user:highlight', { username, highlighted });
}

export default {
  initSocket,
  getSocket,
  disconnectSocket,
  joinStream,
  leaveStream,
  sendChatMessage,
  sendTyping,
  emitStreamStart,
  emitStreamStop,
  sendGift,
  requestViewersList,
  emitUserHighlight
};
